import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { colors, spacing, shadows } from '../../design/tokens';

export const ProfilePage: React.FC = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.email.split('@')[0] || '',
    email: user?.email || '',
    role: user?.role || '',
    company: user?.companyId || 'N/A',
  });
  const [message, setMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('Profile updated successfully! (Simulation)');
    setTimeout(() => setMessage(''), 3000);
  };

  if (!user) return <div style={{ padding: spacing.lg }}>Please login to view profile.</div>;

  return (
    <div style={{ padding: spacing.xl, maxWidth: '600px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: spacing.lg, color: colors.neutral[900] }}>User Profile</h2>
      
      <div style={{ 
        backgroundColor: colors.background.surface, 
        padding: spacing.xl, 
        borderRadius: '12px', 
        boxShadow: shadows.md,
        border: `1px solid ${colors.neutral[200]}`
      }}>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: spacing.md }}>
            <label style={{ display: 'block', marginBottom: spacing.xs, fontWeight: 600, color: colors.neutral[700] }}>
              Email Address (Cannot be changed)
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              readOnly
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: '6px',
                border: `1px solid ${colors.neutral[300]}`,
                backgroundColor: colors.neutral[100],
                color: colors.neutral[600],
                cursor: 'not-allowed',
                outline: 'none'
              }}
            />
          </div>

          <div style={{ marginBottom: spacing.md }}>
            <label style={{ display: 'block', marginBottom: spacing.xs, fontWeight: 600, color: colors.neutral[700] }}>
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: '6px',
                border: `1px solid ${colors.neutral[300]}`,
                backgroundColor: 'white',
                color: colors.neutral[900],
                outline: 'none'
              }}
            />
          </div>

          <div style={{ marginBottom: spacing.md }}>
            <label style={{ display: 'block', marginBottom: spacing.xs, fontWeight: 600, color: colors.neutral[700] }}>
              Role
            </label>
            <input
              type="text"
              value={formData.role}
              readOnly
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: '6px',
                border: `1px solid ${colors.neutral[300]}`,
                backgroundColor: colors.neutral[100],
                color: colors.neutral[600],
                cursor: 'not-allowed',
                outline: 'none'
              }}
            />
          </div>

          {user.companyId && (
            <div style={{ marginBottom: spacing.md }}>
              <label style={{ display: 'block', marginBottom: spacing.xs, fontWeight: 600, color: colors.neutral[700] }}>
                Company ID
              </label>
              <input
                type="text"
                value={formData.company}
                readOnly
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: '6px',
                  border: `1px solid ${colors.neutral[300]}`,
                  backgroundColor: colors.neutral[100],
                  color: colors.neutral[600],
                  cursor: 'not-allowed',
                  outline: 'none'
                }}
              />
            </div>
          )}

          <div style={{ marginTop: spacing.xl }}>
            <button
              type="submit"
              style={{
                backgroundColor: colors.brand.main,
                color: 'white',
                padding: '12px 24px',
                borderRadius: '8px',
                border: 'none',
                fontWeight: 700,
                cursor: 'pointer',
                width: '100%',
                fontSize: '16px',
                boxShadow: shadows.sm
              }}
            >
              Update Profile
            </button>
          </div>

          {message && (
            <div style={{ 
              marginTop: spacing.md, 
              padding: spacing.sm, 
              backgroundColor: colors.healthy.light, 
              color: colors.healthy.dark,
              borderRadius: '6px',
              textAlign: 'center',
              fontWeight: 600
            }}>
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};
